import { Document } from '../../../graphql/graphql';
import { CSSZSickLeaveCertificate } from '../Interfaces/CSSZ.interface';

type SickLeaveDocumentLike = Pick<Document, 'id' | 'createdAt' | 'items'> & {
	childrenDocuments?: Document[] | null;
};

export function transformDocumentToSickLeaveCertificate(
	data: SickLeaveDocumentLike | null | undefined,
): CSSZSickLeaveCertificate | undefined {
	const dataItem = data?.items?.find(item => item?.type === 'sickLeaveData');

	if (!dataItem || !data) {
		return undefined;
	}

	const extra = dataItem.extra as
		| {
				data?: CSSZSickLeaveCertificate['data'];
				status?: string;
		  }
		| null
		| undefined;

	if (!extra?.data) {
		return undefined;
	}

	return {
		id: data.id,
		createdAt: data.createdAt ?? '',
		data: extra.data,
		submissions: data.childrenDocuments ?? [],
		status: extra.status,
		moneyTicket: data.items?.find(
			item => item?.type === 'sickLeaveMoneyTicket',
		),
	};
}
